import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { CustomToast } from '../../../common/Methodcommon';

const styles = {
  box: {
    padding: '1em',
    width: '100%',
    height: 500,
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  label: {
    width: '400px',
    backgroundColor: '#fcfcfc',

    fontSize: '11px',

    padding: 1,
    marginBottom: '2em',
    '&.MuiChecked': {
      color: '#7C0E6F',
    },
  },
  text: {
    fontSize: '12px',

    color: '#464545',
  },
};

const CompanyList = (props) => {
  const [value, setValue] = useState('');
  const [companies, setCompanies] = useState([]);
  const handleChange = (event) => {
    const comapnyChosen = _.find(companies, function (e) {
      return Number(e.companyId) === Number(event.target.value);
    });

    setValue(event.target.value);
    if (!comapnyChosen) return CustomToast('error', 'Error');
    props.onSelect(comapnyChosen.companyId, comapnyChosen.name);
  };

  useEffect(() => {
    setCompanies(props.companies);
    if (props.selectedCompany) {
      setValue(props.selectedCompany);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box style={styles.box}>
      <FormControl
        sx={{ width: '100%', padding: 1 }}
        component="fieldset"
        variant="standard"
      >
        <RadioGroup
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={value}
          onChange={handleChange}
        >
          {_.map(companies, (data) => {
            return (
              <FormControlLabel
                style={styles.label}
                value={data.companyId}
                key={data.companyId}
                control={
                  <Radio
                    size="small"
                    checked={+data.companyId === +value}
                    style={{
                      color: '#7C0E6F',
                      '&.Mui-checked': {
                        color: '#7C0E6F',
                      },
                    }}
                  />
                }
                label={<Typography style={styles.text}>{data.name}</Typography>}
              />
            );
          })}
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default CompanyList;
